import { useLocation } from 'react-router-dom'
import FABBase from '@/components/ui/FAB'
import { useUiStore } from '@/stores/uiStore'

function todayStr() {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

export default function FAB() {
  const location = useLocation()
  const triggerFab = useUiStore(s => s.triggerFab)
  const fabVisible = useUiStore(s => s.fabVisible)

  if (!fabVisible || location.pathname !== '/') return null

  return (
    <FABBase onClick={() => triggerFab(todayStr())}>
      +
    </FABBase>
  )
}
